import React from 'react'
import { IRichTextEditorProps, RichTextEditor } from './RichTextEditor'
import { useUploadFiles } from '../../hooks/useUploadFiles'
import { FileObject, FilePurpose } from '@citruscamps/citrus-client'

interface IProps extends Omit<IRichTextEditorProps, 'extensions' | 'onSelectOrDropFiles'> {
  programId: string
  purpose?: FilePurpose
  onSelectOrDropFiles?: (files: FileObject[]) => Promise<any>
}

export const CheckoutEditor = ({
  programId,
  purpose = 'event_picture',
  onSelectOrDropFiles: handleSelectOrDropFiles,
  ...props
}: IProps) => {
  const { handleBulkUpload } = useUploadFiles({ context: programId })
  return (
    <RichTextEditor
      {...props}
      extensions={['starter', 'image', 'align', 'headers']}
      onSelectOrDropFiles={async (files) => {
        const items = await handleBulkUpload(files, { purpose })
        await handleSelectOrDropFiles?.(items)
        return items.map((item) => ({
          src: item.url,
          alt: item.filename,
          type: item.filetype,
        }))
      }}
    />
  )
}
